import React from 'react'
import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import About from './components/About/About';
import Footer from './components/Footer/Footer';
import Services from './components/Services/Services';
import WebDevelopment from './components/Services/ServicePage/WebDevelopment';
import Seo from './components/Services/ServicePage/Seo';
import ChatBot from './components/Services/ServicePage/ChatBot';
import Contact from './components/Contact/Contact';
import SocialMediaMarketing from './components/Services/ServicePage/SocialMediaMarketing';
import Blog from './components/Blog/Blog';
import BlogPage1 from './components/Blog/BlogPage/BlogPage1';
import BlogPage2 from './components/Blog/BlogPage/BlogPage2';
import BlogPage3 from './components/Blog/BlogPage/BlogPage3';
import Scan2Order from './components/Product/Scan2Order';
import DataAutomation from './components/Services/ServicePage/DataAutomation';


const App = () => {
  return (
    <Router>
    <Navbar/>
      <Routes>
       <Route path='/' element={<Home/>}/>
       <Route path='/about-us' element={<About/>}/>
       <Route path='/services' element={<Services/>}/>
       <Route path='/web-development' element={<WebDevelopment/>}/>
       <Route path='/search-engine-optimization' element={<Seo/>}/>
      
       <Route path='/chat-bot-development' element={<ChatBot/>}/>
       <Route path='/social-media-marketing' element={<SocialMediaMarketing/>}/>

 <Route path='/data-and-automation-services' element={<DataAutomation/>}/>
       <Route path='/scan2order' element={<Scan2Order/>}/>
       <Route path='/blog' element={<Blog/>}/>
       <Route path='/search-engine-optimization-(seo)' element={<BlogPage1/>}/>
       <Route path='/How-Chatbots-Are-Revolutionizing-Modern-Organizations' element={<BlogPage2/>}/>
       <Route path='/Will-AI-replace-Digital-Marketing' element={<BlogPage3/>}/>
       <Route path='/contact-us' element={<Contact/>}/>
      </Routes>
    <Footer/>
    </Router>
  )
}

export default App